import { AppointmentType } from 'router/subrouters/ListingCreationWizard/subrouters/UnderExternalAdministration/default-router/pages/BusinessInfo/utils';

type AppTypeCopyKeys = Exclude<
  AppointmentType,
  'Deceased estate' | 'Bankruptcy' | 'Director-led sale/recapitalisation'
>;

type AppTypeCopy = Record<AppTypeCopyKeys, string>;

export const APPOINTMENT_TYPE_COPIES: AppTypeCopy = {
  'Voluntary administration': 'administratorsAt',
  Liquidation: 'liquidatorsAt',
  Other: 'listedByMult',
  Receivership: 'receiversAt',
};
